import { Box, Divider, Skeleton, Typography } from '@mui/material'
import { session } from 'auth/session'
import Button from 'common/components/Button'
import { OrgsDropdown } from 'common/components/OrgsDropdown'
import { useOrgName } from 'common/hooks/useOrgName'
import { useOrgs } from 'common/hooks/useOrgs'
import { usePageTitle } from 'common/hooks/usePageTitle'
import { CircleOff } from 'lucide-react'

/**
 * This component is shown when the user tries to access an org that does not exist
 * It is meant to help the user navigate to the correct org by selecting it from a dropdown
 */
export const OrgNotFoundPage = () => {
  usePageTitle('Org not found')
  const currentOrg = useOrgName()
  const { isLoadingOrgs } = useOrgs()

  return (
    <Box
      sx={{
        flex: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: '100vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        <CircleOff size={30} style={{ marginTop: '10px' }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Typography variant="h1">Org {currentOrg} Not Found</Typography>
          <Typography variant="textPrimary" color="text.secondary">
            Please make sure you are accessing the correct org
          </Typography>
          {isLoadingOrgs ? (
            <Skeleton variant="rect" width="100%" height="28px" />
          ) : (
            <OrgsDropdown
              showFreeTag={false}
              showSelectedOrg={false}
              sx={{
                width: '100%',
              }}
              selectProps={{
                value: 'Select org',
                type: 'menu',
                icon: null,
                buttonProps: {
                  // size: 'tiny',
                  color: 'secondary',
                  sx: {
                    width: '100%',
                    p: 1,
                  },
                },
                wrapperProps: {
                  sx: {
                    width: '100% !important',
                  },
                },
              }}
              allowAddNew={false}
            />
          )}
          <Divider />
          <Typography variant="textPrimary" color="text.secondary">
            If you believe this is an error, please contact us at support@serverless.com
          </Typography>
          <Button
            onClick={() => session.destroy()}
            size="small"
            color="secondary"
            variant="text"
            sx={{
              margin: 'auto',
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
export default OrgNotFoundPage
